import React from 'react'
import Layout from '../Layout'
import PostAuctio from '../../../utils/CommonFunctionality/PostAuction'
const PostAuction = (props) => {
    return (
        <>
            <Layout props={props}>
                <div className="postProductContainer">
                    <PostAuctio
                        defaultCountryCode={38}
                        addressSection={1}
                        extraSection={1}
                        foodIndustryFields={1}
                        theme="FoodIndustry"
                        taxFree={1}
                    />
                </div>
            </Layout>
        </>
    )
}

export default PostAuction
